import React from 'react';
import { QuestionMark } from 'react-design-components';
import { HelpModal } from 'react-commons';
import { ChoiceWrapper, LegalChoiceButton } from '../Elements';
import { UnionHelp } from '../Help';
import useHasUnionOptions from './hooks/useHasUnionOptions';
import { FlowEnum, ComponentsEnum } from '../../types';
import { MainLayout } from '../MainLayout';

interface Props {
  nextUrl: Array<string>;
  progress?: number;
  flow?: FlowEnum;
}

const HasUnionOptions: React.FC<Props> = (props: Props) => {
  const { nextUrl, progress, flow } = props;

  const { t, classes, onYes, onNo, toggleHelpModal } = useHasUnionOptions(nextUrl);

  return (
    <MainLayout
      navigationId={ComponentsEnum.LEGAL}
      flow={flow}
      progress={progress}
      directAccess={false}
      t={t}
      pageTitle="page_title"
    >
      <HelpModal>
        <UnionHelp />
      </HelpModal>
      <div className={classes.alignBottom}>
        <QuestionMark onHelpClick={toggleHelpModal} title={t('title')}>
          <ChoiceWrapper>
            <LegalChoiceButton onClick={onYes}>
              <span className={classes.legalTitle}>{t('yes')}</span>
              <span className={classes.legalDescription}>{t('yes_title')}</span>
            </LegalChoiceButton>
            <LegalChoiceButton onClick={onNo}>
              <span className={classes.legalTitle}>{t('no')}</span>
              <span className={classes.legalDescription}>{t('no_title')}</span>
            </LegalChoiceButton>
          </ChoiceWrapper>
        </QuestionMark>
      </div>
    </MainLayout>
  );
};

export default HasUnionOptions;
